module.exports = __webpack_public_path__ + "media/sustainable_sales/coming_soon-68831aa8.png";